import { render, staticRenderFns } from "./PizzaGraph.vue?vue&type=template&id=d60aae9a&scoped=true"
import script from "./PizzaGraph.vue?vue&type=script&lang=js"
export * from "./PizzaGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60aae9a",
  null
  
)

export default component.exports